import { useState, useEffect } from "react";
import AddCircle from "@mui/icons-material/AddCircleRounded";
import SearchIcon from "@mui/icons-material/SearchTwoTone";
import { InputGroup, Button, Col, Accordion, Row, Card, Spinner } from "react-bootstrap";
import _ from "lodash";
import { FormProvider, useForm, Controller } from "react-hook-form";
import { useLocation, useNavigate } from "react-router-dom";
import DataGridPromoCategoryAgent from "./DataGridPromoCategoryAgent";
import ApiPromocategorycommision from "../../../core/api/api.promocategorycommision";
import ApiPromocategoryagent from "../../../core/api/api.promocategoryAgent";
import { NewPromoCategoryAgentModal } from "./NewPromoCategoryAgentModal";
import ApiAgent from "../../../core/api/api.agent";
import ApiPromoCategory from "../../../core/api/api.promocategory";
import { tools } from "../../../core/utils/tools";
import SelectComponent from "../_Components/ReactSelectComponent";
import GlobalFormControl from "../_Components/GlobalFormControl";

const Index = () => {
  let location = useLocation();
  let navigate = useNavigate();
  const searchParams = new URLSearchParams(location.search);
  const [listData, setListData] = useState({});
  // const [checkBoxList2, setCheckBoxList2] = useState([]);
  const [refresh, setRefresh] = useState(false);
  const [showModalPromoCategoryAgent, setShowModalPromoCategoryAgent] = useState(false);
  const [selectedAgent, setSelectedAgent] = useState(null);
  const [promoCategory, setPromoCategory] = useState([]);
  const [allAgentList, setAllAgentList] = useState([]);
  const [allCommisionList, setAllCommisionList] = useState([]);
  const {
    register,
    handleSubmit,
    control,
    formState: { errors, isSubmitting },
    getValues,
    setValue,
    watch,
  } = useForm({});
  const methods = { register, handleSubmit, control, formState: { errors, isSubmitting }, getValues, setValue, watch };
  useEffect(() => {
    (async () => {
      try {
        const pageSizeFromUrl1 = searchParams.get("pageSize");
        const pageSizeFromUrl = !_.isEmpty(pageSizeFromUrl1) ? _.toNumber(pageSizeFromUrl1) : getValues("pageSize");
        const pageNumberFromUrl1 = searchParams.get("pageNumber");
        const pageNumberFromUrl = !_.isEmpty(pageNumberFromUrl1)
          ? _.toNumber(pageNumberFromUrl1)
          : getValues("pageNumber");
        const agentIdFromUrl = searchParams.get("agentId");
        const promoCategoryIdFromUrl = searchParams.get("promoCategoryId");
        const promoCategoryCommisionIdFromUrl = searchParams.get("promoCategoryCommisionId");

        let objData = {
          agentId: !_.isEmpty(agentIdFromUrl) ? _.toString(agentIdFromUrl) : 0,
          promoCategoryId: !_.isEmpty(promoCategoryIdFromUrl) ? _.toString(promoCategoryIdFromUrl) : 0,
          promoCategoryCommisionId: !_.isEmpty(promoCategoryCommisionIdFromUrl)
            ? _.toString(promoCategoryCommisionIdFromUrl)
            : 0,
          globalSearch: searchParams.get("globalSearch"),
        };
        const data = await ApiPromocategoryagent.getAll({
          globalSearch: JSON.stringify(objData),
          pageSize: pageSizeFromUrl,
          pageNumber: pageNumberFromUrl,
        });
        setListData(data);
        setValue("totalCount", data.totalCount);

        const resultPromoCategory = await ApiPromoCategory.getAll({ pageSize: 200, pageNumber: 1 });
        if (resultPromoCategory?.data) {
          setPromoCategory(resultPromoCategory.data);
          resultPromoCategory?.data && resultPromoCategory.data.unshift({ id: 0, name: "انتخاب" });
        }
        const restAgent = await ApiAgent.getAllAgentsName();
        setAllAgentList(restAgent);
        restAgent.unshift({ id: 0, companyName: "انتخاب" });

        const restPCCommision = await ApiPromocategorycommision.getAll({ pageSize: 200, pageNumber: 1 });

        restPCCommision?.data && restPCCommision.data.unshift({ id: 0, name: "انتخاب" });

        restPCCommision?.data && setAllCommisionList(restPCCommision.data);
        const formInputs = [
          {
            name: "agentId",
            type: "multiSelect",
            isMulti: false,
            data: restAgent.map((obj) => {
              return { id: obj.id, title: obj.companyName };
            }),
          },
          { name: "promoCategoryId", type: "multiSelect", isMulti: false, data: resultPromoCategory.data },
          { name: "promoCategoryCommisionId", type: "multiSelect", isMulti: false, data: restPCCommision.data },
          { name: "globalSearch", type: "text" },
          { name: "pageSize", type: "number" },
          { name: "pageNumber", type: "number" },
        ];
        tools.setInputsValues_ReactHookFrom(setValue, searchParams, formInputs);
      } catch (error) {
      } finally {
      }
    })();

    return () => { };
  }, [refresh]);
  const callBackJustForRunUseEffect = () => {
    setRefresh(!refresh);
  };
  const onSubmit = async (data) => {
    let objData = {
      agentId: data?.agentId?.value,
      promoCategoryId: data?.promoCategoryId?.value,
      promoCategoryCommisionId: data?.promoCategoryCommisionId?.value,
      globalSearch: data.globalSearch,
    };
    let dataToSendUrl = {
      ...objData,
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
    };
    const apiData = await ApiPromocategoryagent.getAll({
      pageSize: data.pageSize,
      pageNumber: getValues("pageNumber"),
      globalSearch: JSON.stringify(objData),
    });
    setListData(apiData);
    setValue("totalCount", apiData.totalCount);
    //ارسال داده های فرم به تابع پس از حذف آیتم های اضافه
    var queryString = tools.createQueryStringFromFromData(_.omit(dataToSendUrl, ["totalPages", "totalCount"]));
    navigate(`/promoCategoryAgent?${queryString}`);
  };
  // async function handleGroupEdit() {
  //   if (!_.isEmpty(checkBoxList2)) {
  //     navigate({
  //       pathname: "/promoCategoryAgent/" + checkBoxList2[0].id,
  //       state: { neWPromoCategoryAgent: true, AgentId: checkBoxList2[0].id, data: checkBoxList2 },
  //     });
  //   } else {
  //     SwalMessage({ title: "گروهی انتخاب نشده است", iSsuccess: false });
  //   }
  // }

  // async function handleRemoveItem(flag) {
  //   if (!_.isEmpty(checkBoxList2)) {
  //     let PromoCategoryAgentList = [];
  //     let tt = checkBoxList2.map((item) => PromoCategoryAgentList.push(item.id));
  //     var rest = ApiPromocategoryagent.removePromoCategoryAgent({
  //       Id: PromoCategoryAgentList,
  //       IsActive: flag == 1 ? true : false,
  //     }).then((result) => {
  //       SwalMessage({ title: result.message, iSsuccess: result.data });
  //     });
  //   } else {
  //     SwalMessage({ title: "گروهی انتخاب نشده است", iSsuccess: false });
  //   }
  //   callBackJustForRunUseEffect();
  // }

  const inputChangeHandlerPromoCategory = (event) => {
    setValue("promoCategoryId", event);
  };
  const inputChangeHandlerAgent = (event) => {
    setValue("agentId", event);
  };
  const inputChangeHandlerPromoCategoryCommision = (event) => {
    setValue("promoCategoryCommisionId", event);
  };
  return (
    <div>
      {!_.isEmpty(location.state) && location.state?.neWPromoCategoryAgent ? (
        <NewPromoCategoryAgentModal callback={callBackJustForRunUseEffect} />
      ) : location?.state?.neWPromoCategoryAgent?.AgentId > 0 ? (
        <NewPromoCategoryAgentModal callback={callBackJustForRunUseEffect} />
      ) : (
        <></>
      )}
      <div className={`card card-custom`}>
        {/* Start Box Header */}
        <div className="card-header border-0 pt-5">
          <h3 className="card-title align-items-start flex-column">
            <span className="card-label font-weight-bolder text-dark">تخصیص گروه تخفیف به نمایندگان</span>
            <span className="text-muted mt-3 font-weight-bold font-size-sm">لیست گروه های تخصیص یافته به نمایندگان</span>
          </h3>
          <div className="card-toolbar">
            {/* <div className="btn btn-success mr-1 mb-2 mb-xl-0">
              <span className="font-weight-bold font-size-sm " onClick={() => handleRemoveItem(1)}>
                <DoneAll className="mr-1" />
                فعال
              </span>
            </div>
            <div className="btn btn-danger mr-1 mb-2 mb-xl-0">
              <span className="font-weight-bold font-size-sm" onClick={() => handleRemoveItem(0)}>
                <RemoveDone className="mr-1" />
                غیر فعال{" "}
              </span>
            </div>
            <div className="btn btn-warning mr-1 mb-2 mb-xl-0">
              <span className="font-weight-bold font-size-sm" onClick={() => handleGroupEdit()}>
                <EditIcon className="mr-1" />
                ویرایش گروهی
              </span>
            </div> */}
            <Button
              className=" mb-2 mb-xl-0"
              onClick={() => {
                setSelectedAgent(0);
                setShowModalPromoCategoryAgent(true);
              }}
            >
              <AddCircle className="mr-1" />
              تخصیص گروه جدید تخفیف به نمایندگان
            </Button>
          </div>
        </div>

        {/*Start body */}
        <div className="card-body pt-3 pb-0">
          <FormProvider {...methods}>
            <form id="form" onSubmit={methods.handleSubmit(onSubmit)}>
              {/* search box */}
              <div className="border-top pt-3">
                {/* {Serach} */}
                <Accordion>
                  <Card>
                    <Accordion.Header as={Card.Header} variant="link">
                      <Card.Title className="py-0 pl-0 text-gray fs-normal">جستجو پیشرفته</Card.Title>
                    </Accordion.Header>
                    <Accordion.Body>
                      <Card.Body>
                        <Row>
                          <Col xs="12" sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="agentId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={allAgentList?.map((item) => ({
                                    value: item.id,
                                    label: item.companyName,
                                  }))}
                                  placeholder="نماینده"
                                  className=" mt-2"
                                  field={field}
                                  onChange={inputChangeHandlerAgent}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="promoCategoryId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={promoCategory?.map((item) => ({
                                    value: item.id,
                                    label: item.name,
                                  }))}
                                  placeholder="گروه تخفیف"
                                  className=" mt-2"
                                  field={field}
                                  onChange={inputChangeHandlerPromoCategory}
                                />
                              )}
                            />
                          </Col>
                          <Col sm="6" xl="3" className="tb-reponsive  px-2">
                            <Controller
                              name="promoCategoryCommisionId"
                              control={control}
                              render={({ field }) => (
                                <SelectComponent
                                  options={allCommisionList?.map((item) => ({
                                    value: item.id,
                                    label: item.name,
                                  }))}
                                  placeholder="گروه کمیسیون"
                                  className="mt-2"
                                  field={field}
                                  onChange={inputChangeHandlerPromoCategoryCommision}
                                />
                              )}
                            />
                          </Col>
                        </Row>
                        <Row>
                          <Col className="tb-reponsive px-2 mt-3 mt-xl-0 mx-auto">
                            <Button variant="success" type="submit" disabled={isSubmitting} className=" mt-3">
                              {isSubmitting && <Spinner animation="border" variant="warning" size="sm" />}
                              <SearchIcon />
                              جستجو
                            </Button>
                          </Col>
                        </Row>
                      </Card.Body>
                    </Accordion.Body>
                  </Card>
                </Accordion>
                <InputGroup className="my-3">
                  <Controller
                    name="globalSearch"
                    control={control}
                    render={({ field: { onChange, value } }) => (
                      <GlobalFormControl
                        type="text"
                        aria-describedby="basic-addon1"
                        placeholder="جستجو ..."
                        name="globalSearch"
                        value={value || ""}
                        onChange={onChange}
                      />
                    )}
                  />

                  <Button variant="secondary" type="submit" disabled={isSubmitting}>
                    <SearchIcon />
                  </Button>
                </InputGroup>
              </div>

              {/* table */}
              <Col xs="12" className="tb-reponsive px-0">
                {
                  <DataGridPromoCategoryAgent
                    data={listData}
                    // setCheckBoxList2={setCheckBoxList2}
                    callBack={callBackJustForRunUseEffect}
                  />
                }
              </Col>
              {showModalPromoCategoryAgent && (
                <NewPromoCategoryAgentModal
                  showModalPromoCategoryAgent={showModalPromoCategoryAgent}
                  setShowModalPromoCategoryAgent={setShowModalPromoCategoryAgent}
                  selectedAgent={selectedAgent}
                />
              )}
            </form>
          </FormProvider>
        </div>
      </div>
    </div>
  );
};

export default Index;
